import { useParams } from 'react-router-dom'

export type UseNumericParamsPayload = {
  [key: string]: number,
}

function useNumericParams(): UseNumericParamsPayload {
  const params = useParams<{ [key: string]: string }>()

  const numericParams = Object.keys(params).reduce((acc, paramKey) => {
    const value = params[paramKey] ? Number(params[paramKey]) : null

    if (value && !Number.isNaN(value)){
      acc[paramKey] = value
    }

    return acc
  }, {} as UseNumericParamsPayload)

  return numericParams
}

export default useNumericParams
